import { EMPTY_OBJECT } from '../../../../../constants/common'

import { LISTING_PROFILE_TAB_COUNT_LIMIT } from './RentalPortalListingProfileTabs.constants'

function getListingProfileTabCount(total) {
  return total > LISTING_PROFILE_TAB_COUNT_LIMIT
    ? `${LISTING_PROFILE_TAB_COUNT_LIMIT}+`
    : total || undefined
}

export function getListingProfileTabCounters(listingData) {
  return Object.entries(listingData?.counts || EMPTY_OBJECT).reduce(
    (acc, [section, total]) => {
      acc[section] = { total: getListingProfileTabCount(total) }

      return acc
    },
    {}
  )
}
